
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Acluxuryfourfive() {



    const cardData =
    {
        keyword: 'Ac Luxury 45 Seater Bharat Benz Bus Hire Ahmednagar',
        heading: 'Amruta Travels: Ac Luxury 45 Seater Bharat Benz Bus Hire Ahmednagar',
        headingDescription: 'Amruta Travels offers AC Luxury 45 Seater BharatBenz Bus Hire in Ahmednagar, delivering premium group transportation with unmatched comfort and reliability. Whether you are organizing a corporate retreat, wedding, school excursion, or pilgrimage, our 45-seater BharatBenz buses are designed to provide a smooth and luxurious travel experience. Equipped with air-conditioned interiors, plush seating, ample legroom, and generous luggage space, these buses ensure every journey is enjoyable and stress-free. With professional drivers, punctual service, and 24/7 customer support, Amruta Travels is your trusted partner for group travel in and around Ahmednagar.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

   "services": [
    {
      "name": "Pune to Ahmednagar 45 Seater Bus Hire",
      "description": "Amruta Travels offers 45-seater AC buses for hire from Pune to Ahmednagar, ideal for large groups, events, or pilgrimages. These buses are equipped with pushback seats, air conditioning, and professional drivers to ensure a smooth and comfortable journey."
    },
    {
      "name": "Bharat Benz AC Luxury Bus for Ahmednagar Tour",
      "description": "Travel in luxury with our Bharat Benz AC buses from Pune to Ahmednagar. Designed for long-distance comfort, these coaches are perfect for VIP group tours, offering plush seating, AC, entertainment systems, and spacious interiors for a premium experience."
    },
    {
      "name": "Corporate/Wedding Bus Ahmednagar",
      "description": "Book luxury buses for corporate or wedding travel between Pune and Ahmednagar. Whether it’s a company outing, conference, or marriage function, we provide well-maintained AC coaches with professional service for your group’s comfort and punctuality."
    },
    {
      "name": "Group Tour Bus Hire Ahmednagar",
      "description": "Organize group travel to Ahmednagar with ease. Our group tour buses cater to families, school trips, societies, and office teams, ensuring a coordinated and relaxing journey with ample space and travel-friendly amenities."
    },
    {
      "name": "Outstation AC Coach Ahmednagar",
      "description": "Hire an outstation AC coach from Pune to Ahmednagar for multi-day trips or single-day returns. Our fleet includes a variety of seater options with AC and reclining seats to provide a fatigue-free travel experience for all passengers."
    },
    {
      "name": "Family Function Bus Rental",
      "description": "Attending a family event in Ahmednagar? Amruta Travels offers bus rental services for weddings, engagements, and reunions with clean, air-conditioned, and comfortable seating suitable for all age groups."
    },
    {
      "name": "Volvo Bus for Ahmednagar Darshan",
      "description": "Experience a serene pilgrimage or city tour to Ahmednagar in a Volvo AC coach. These luxury buses come with superior suspension, modern interiors, and onboard comfort for long hours of spiritual or sightseeing travel."
    },
    {
      "name": "Religious Trip Bus Ahmednagar",
      "description": "Amruta Travels provides bus rental services for religious tours from Pune to Ahmednagar. Ideal for temple visits, spiritual journeys, and darshan tours, our buses are equipped for comfort and safety over long-distance travel."
    },
    {
      "name": "VIP Wedding Bus Pune",
      "description": "Make wedding guest transport hassle-free with our VIP luxury bus rental services from Pune. Choose from our range of AC coaches and luxury buses for guest movement to Ahmednagar in comfort and style."
    },
    {
      "name": "Executive Bus for Ahmednagar Trip",
      "description": "For business meetings or corporate retreats in Ahmednagar, book our executive AC buses from Pune. Perfectly suited for professionals, these coaches offer on-board amenities, ample legroom, and smooth rides."
    },
    {
      "name": "College Tour Bus Ahmednagar",
      "description": "Plan educational trips to Ahmednagar with our college tour bus services. Amruta Travels offers safe and organized travel with large capacity AC buses, certified drivers, and complete end-to-end transport management."
    },
    {
      "name": "Pune Bus for Historical Tours",
      "description": "Visit Ahmednagar’s historical landmarks like Ahmednagar Fort and heritage sites with our specialized tour buses. Ideal for tourists, historians, and school groups, these AC buses ensure informative and relaxed travel."
    },
    {
      "name": "Luxury Bus Booking Ahmednagar",
      "description": "Choose Amruta Travels for luxury bus bookings from Pune to Ahmednagar. Our fleet includes high-end AC coaches with cushioned seating, clean interiors, and modern features for a first-class group travel experience."
    },
    {
      "name": "Ahmednagar to Pune Bus Hire",
      "description": "Need return transport from Ahmednagar to Pune? We offer one-way and round-trip bus hire options with flexible timings, clean vehicles, and courteous staff for weddings, events, or corporate needs."
    },
    {
      "name": "Festival Trip Bus Rental",
      "description": "Celebrate festivals with your group by booking an AC bus from Pune to Ahmednagar. Ideal for Holi, Diwali, Ganeshotsav, or Eid, our buses are well-maintained and provide safe and timely travel solutions."
    }
  ],
  "tableData": [
    ["Pune to Ahmednagar 45 Seater Bus Hire", "Bharat Benz AC Luxury Bus for Ahmednagar Tour"],
    ["Corporate/Wedding Bus Ahmednagar", "Group Tour Bus Hire Ahmednagar"],
    ["Outstation AC Coach Ahmednagar", "Family Function Bus Rental"],
    ["Volvo Bus for Ahmednagar Darshan", "Religious Trip Bus Ahmednagar"],
    ["VIP Wedding Bus Pune", "Executive Bus for Ahmednagar Trip"],
    ["College Tour Bus Ahmednagar", "Pune Bus for Historical Tours"],
    ["Luxury Bus Booking Ahmednagar", "Ahmednagar to Pune Bus Hire"],
    ["Festival Trip Bus Rental"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "AC Luxury 45 Seater Bharat Benz Bus Hire in Ahmednagar",
    "WhyChoosedescription": "Amruta Travels offers the luxurious and comfortable AC 45 Seater Bharat Benz buses for hire in Ahmednagar. Whether you are planning a corporate trip, family outing, or religious pilgrimage, our buses ensure a premium travel experience with top-notch comfort and reliability."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Travel for Large Groups",
    "WhyChoosedescription": "Our AC Luxury 45 Seater Bharat Benz buses provide a spacious, air-conditioned environment for large groups. With ample legroom, wide windows, and plush seating, your group can enjoy a smooth and comfortable journey, no matter the distance to Ahmednagar."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Family, and Religious Group Travel",
    "WhyChoosedescription": "Whether you're heading to Ahmednagar for a corporate event, a family trip, or a religious pilgrimage, our luxury buses are ideal for all types of group travel. We offer the perfect solution for large groups looking to travel together in comfort and style."
  },
  {
    "WhyChooseheading": "Professional Drivers for Safe and Timely Travel",
    "WhyChoosedescription": "Our highly trained and experienced drivers are well-versed with the routes in and around Ahmednagar. They ensure that your journey is smooth, punctual, and safe, while offering a courteous and professional service throughout the trip."
  },
  {
    "WhyChooseheading": "Well-Maintained Buses for a Worry-Free Journey",
    "WhyChoosedescription": "Our fleet of AC Luxury 45 Seater Bharat Benz buses is regularly maintained and inspected to ensure the highest standards of safety and performance. We prioritize the reliability of our buses, ensuring that your journey to Ahmednagar is hassle-free and enjoyable."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Luxury Travel",
    "WhyChoosedescription": "Amruta Travels offers competitive and transparent pricing for luxury bus hire. Our rates include fuel, tolls, driver allowances, and taxes, with no hidden fees. This makes it easy for you to plan your travel budget for your trip to Ahmednagar."
  },
  {
    "WhyChooseheading": "Customized Solutions to Meet Your Specific Requirements",
    "WhyChoosedescription": "We understand that every group has unique needs. Whether you need specific pick-up and drop-off locations or have special requests, Amruta Travels can customize the bus hire service to suit your requirements, ensuring a seamless travel experience for your group."
  },
  {
    "WhyChooseheading": "Easy Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking an AC Luxury 45 Seater Bharat Benz bus with Amruta Travels is easy and convenient. You can reserve your bus online, by phone, or by visiting our office. Our customer support team is available 24/7 to assist with bookings, changes to your itinerary, or any other travel-related inquiries."
  }
]

























    }

const faqData = [
  {
    question: 'Can I hire an AC Luxury 45-seater Bharat Benz bus for a trip to Ahmednagar with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers AC Luxury 45-seater Bharat Benz buses for hire for trips to Ahmednagar. Our luxury buses are designed to provide a comfortable and high-end travel experience, making your journey to Ahmednagar both relaxing and enjoyable.',
  },
  {
    question: 'What amenities are available in the AC Luxury 45-seater Bharat Benz bus?',
    answer: 'The AC Luxury 45-seater Bharat Benz buses are equipped with premium amenities such as comfortable reclining seats, air conditioning, USB charging ports, overhead storage, entertainment systems, ample legroom, and sanitized interiors. Everything is designed for a luxurious and comfortable travel experience.',
  },
  {
    question: 'Is the AC Luxury 45-seater Bharat Benz bus suitable for both local and outstation travel?',
    answer: 'Yes, the AC Luxury 45-seater Bharat Benz bus is perfect for both local travel within Ahmednagar and outstation trips. Whether it’s a corporate outing, a family tour, or a pilgrimage trip, this bus ensures maximum comfort for long-distance journeys.',
  },
  {
    question: 'Is a driver included in the bus rental for the Ahmednagar trip?',
    answer: 'Yes, every rental of the AC Luxury 45-seater Bharat Benz bus includes a professional and experienced driver. Our drivers ensure that your trip to Ahmednagar is smooth, safe, and on schedule, while also being familiar with the best routes to take.',
  },
  {
    question: 'How much does it cost to hire an AC Luxury 45-seater Bharat Benz bus for a trip to Ahmednagar?',
    answer: 'The cost of hiring an AC Luxury 45-seater Bharat Benz bus for a trip to Ahmednagar depends on factors such as distance, duration, and specific requirements. Rates typically start from ₹35–₹45 per km. For an exact quote, please contact us with your travel details.',
  },
  {
    question: 'Is the AC Luxury 45-seater Bharat Benz bus comfortable for long journeys?',
    answer: 'Yes, the AC Luxury 45-seater Bharat Benz bus is designed to ensure maximum comfort on long journeys. The luxury seats, spacious interiors, and smooth ride make it the perfect choice for long-distance travel to Ahmednagar, offering a relaxed experience throughout the journey.',
  },
  {
    question: 'Are the buses well-maintained and sanitized?',
    answer: 'Absolutely. All our buses, including the AC Luxury 45-seater Bharat Benz, are thoroughly inspected, cleaned, and sanitized before each trip to ensure the highest standards of hygiene, safety, and comfort for all passengers.',
  },
  {
    question: 'How do I book an AC Luxury 45-seater Bharat Benz bus for a trip to Ahmednagar?',
    answer: 'Booking an AC Luxury 45-seater Bharat Benz bus for your trip to Ahmednagar is simple. You can book online through our website or contact our customer support team for quick booking assistance and personalized services to meet your travel needs.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Raghav Kulkarni',
    role: 'Corporate Executive, Pune',
    text: 'We hired an AC Luxury 45-seater Bharat Benz bus for a corporate trip to Ahmednagar. The bus was extremely luxurious, well-maintained, and the driver was very professional. The entire journey was comfortable, and we had a great experience with Amruta Travels.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Seema Patil',
    role: 'Family Trip Organizer, Pune',
    text: 'I booked an AC Luxury 45-seater Bharat Benz bus for a family trip to Ahmednagar. The bus was spacious, the amenities were perfect, and the journey was smooth. We felt like we were traveling in luxury. I highly recommend Amruta Travels for any group travel.',
    rating: 5,
  },
];
































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC Luxury 45 Seater Bharat Benz Bus Hire Ahmednagar",
  "image": "https://bushireinpune.com/assets/images/45-seater-bharat-benz-ahmednagar.jpg",
  "description": "Amruta Travels offers AC Luxury 45 Seater Bharat Benz Bus Hire for your trip to Ahmednagar. Perfect for corporate trips, weddings, family functions, religious tours, and group travel. Hire premium AC coaches, including Volvo and Bharat Benz, for a comfortable journey from Pune to Ahmednagar. Explore historical sites, attend events, or travel for festivals in luxury.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "14564"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "18000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/ac-luxury-45-seater-bharat-benz-bus-hire-ahmednagar"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | AC Luxury 45 Seater Bharat Benz Bus Hire Ahmednagar | Pune to Ahmednagar & Religious Tours</title>
  <meta 
    name="description" 
    content="Hire an AC Luxury 45 Seater Bharat Benz bus for your trip to Ahmednagar. Book premium buses for corporate, wedding, religious, and family functions. Comfortable and safe travel for group tours and historical trips from Pune to Ahmednagar." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/91.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Acluxuryfourfive;